import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  ActionConflictHistory,
  ActionConflictHistoryList,
  ActionConflictsList,
  ActionConflictsShow,
  AuditQueueWarning,
  BulkRemove,
  CoachableReportList,
  CoachableReportShow,
  HistoryShow,
  InvalidFactorList,
  InvalidFactorShow,
  List,
  LorDesignationShow,
  MatchesList,
  Metrics,
  MissingLOR,
  Next,
  NoaError,
  Redirect,
  SearchList,
  Show,
  SplitNOAsList,
  SplitNOAsShow,
  Success,
} from './NoaRouteComponents';

const basePath = adminRoutes.noa;

export const noaRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: ActionConflictsList,
    path: `${basePath}/action_conflicts`,
  },
  {
    Component: ActionConflictHistoryList,
    path: `${basePath}/action_conflicts/history`,
  },
  {
    Component: ActionConflictHistory,
    path: `${basePath}/action_conflicts/history/:id`,
  },
  {
    Component: ActionConflictsShow,
    path: `${basePath}/action_conflicts/:id`,
  },
  {
    Component: LorDesignationShow,
    path: `${basePath}/pending_lor_designation/:id`,
  },
  {
    Component: BulkRemove,
    path: `${basePath}/bulk_remove`,
  },
  {
    Component: SplitNOAsList,
    path: `${basePath}/split_noas`,
    permitOnly: [UserRoles.OpsManager],
  },
  {
    Component: SplitNOAsShow,
    path: `${basePath}/split_noas/:id`,
    permitOnly: [UserRoles.OpsManager],
  },
  {
    Component: CoachableReportList,
    path: `${basePath}/coachable_report`,
  },
  {
    Component: CoachableReportShow,
    path: `${basePath}/coachable_report/:id`,
  },
  {
    Component: HistoryShow,
    path: `${basePath}/history/:id`,
  },
  {
    Component: SearchList,
    path: `${basePath}/search`,
  },
  {
    Component: Metrics,
    path: `${basePath}/metrics`,
  },
  {
    Component: InvalidFactorShow,
    path: `${basePath}/pending_factors/:id`,
  },
  {
    Component: InvalidFactorList,
    path: `${basePath}/pending_factors`,
  },
  {
    Component: MissingLOR,
    path: `${basePath}/missing_lor`,
  },
  {
    Component: List,
    path: basePath,
  },
  {
    Component: AuditQueueWarning,
    path: `${basePath}/audit_queue_warning`,
  },
  {
    Component: NoaError,
    path: `${basePath}/error`,
  },
  {
    Component: MatchesList,
    path: `${basePath}/matches`,
  },
  {
    Component: Redirect,
    path: `${basePath}/:id/redirect`,
  },
  {
    Component: Next,
    path: `${basePath}/:id/next`,
  },
  {
    Component: Show,
    path: `${basePath}/process`,
  },
  {
    Component: Success,
    path: `${basePath}/success`,
  },
  {
    Component: Show,
    path: `${basePath}/:id`,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
